const path = "/app/enrollment";

export const enrollmentRouteMeta = [
  {
    type: "redirect",
    key: "DEPLOYMENT",
    from: path,
    to: `${path}/devices`,
    exact: true,
  },
  {
    type: "route",
    key: "DEPLOYMENT",
    path: `${path}/devices/*`,
    subPages: [
      { key: "ENROLLED_DEVICES", path: `${path}/devices/enrolled` },
      { key: "UNMANAGED_DEVICES", path: `${path}/devices/yet-to-enroll` },
    ],
  },
  { type: "route", key: "DOMAIN", path: `${path}/domain` },
  { type: "route", key: "CONNECTOR", path: `${path}/connector` },
  {
    type: "route",
    key: "BULK_DEPLOYMENT_GPO",
    path: `${path}/deployment/gpo`,
  },
  {
    type: "route",
    key: "BULK_DEPLOYMENT_INTUNE",
    path: `${path}/deployment/intune`,
  },
  {
    type: "route",
    key: "BULK_DEPLOYMENT_SCCM",
    path: `${path}/deployment/sccm`,
  },
  {
    type: "route",
    key: "BULK_DEPLOYMENT_AZURE",
    path: `${path}/deployment/azure`,
  },
  { type: "route", key: "DOMAIN", path: `${path}/check` },
];
